enum LoginVariables {
  LoginUrl = '/saml2/SingleSignOn.ashx?source=website&ReturnUrl=##returnUrl##&origin=##origin##&sc_site=##site##'
}
export default LoginVariables
